/*import 'popper.js';
import 'bootstrap';
*/
(function ($, Drupal) {

  'use strict';

  $(document).ready(function(){

    // Interceptamos eventos del megamenu para evitar comportamientos erroneos
    // Al hacer click en un tab, añadimos al dropdown una clase "no cerrar".
    // justo antes de que se cierre el dropdown comprobamos si tiene la clase para
    // evitar el cierre o permitirlo.

    $('.dropdown-menu').on('click', function(e){
      $(this).closest('.dropdown').addClass('dontClose');
    });

    $('.megamenu').on('shown.bs.dropdown', function(e) {
      $('header').addClass('megamenu-open');
    });

    $('.megamenu').on('hidden.bs.dropdown', function(e) {
      $('header').removeClass('megamenu-open');
    });

    $('#megamenu-estudios').on('show.bs.dropdown', function(e) {
      $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
    });

    $('#megamenu-estudios').on('hide.bs.dropdown', function(e) {
      if ( $(this).hasClass('dontClose') ){
        e.preventDefault();
      }else{
        $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
      }
      $(this).removeClass('dontClose');
    });

    $('.js--close').click(function (event) {
      $('header .navbar .dropdown.show .dropdown-toggle').dropdown('toggle');
    });

    /**
     * APERTURA DE ACORDEONES  POR URL
     */
    var $hash = location.hash;
    if ($hash && $hash[1]!=="/") {
      $('.collapse.show').removeClass('show'); //cerramos todos los acordeones
      var $collapseItem = $($hash).addClass('show');
      $('html,body').animate({ scrollTop: $collapseItem.parent().offset().top }, 250);
    }

    /**
     * Fix versión móvil para mostrar el modal de solicitud de información sobre el menú móvil
     */

    $('#solicitaInformacion').on('show.bs.modal', function(){
      $('.mm-page').css('position', 'initial');
    });
    $('#solicitaInformacion').on('hidden.bs.modal', function(){
      $('.mm-page').css('position', 'relative');
    });

    /* Inicialización de ekko-lightbox */
    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
      event.preventDefault();
      $(this).ekkoLightbox({
        alwaysShowClose: true
      });
    });

    /*
      En caso de scroll añadimos una clase al body para cabecera sticky
     */
    $(window).scroll(function(){
      var winTop = $(window).scrollTop();
      if(winTop >= 16){
        $("body").addClass("js--sticky-header");
      }else{
        $("body").removeClass("js--sticky-header");
      }//if-else
      if(winTop >= 78){
        $("header .bg-info").addClass("js--sticky-nav");
      }else{
        $("header .bg-info").removeClass("js--sticky-nav");
      }
    });//win func.


    //inicializar efecto de carga asincrona de imágenes
    window.bLazy = new Blazy({
      success: function(element){
        setTimeout(function(){
          // We want to remove the loader gif now.
          // First we find the parent container
          // then we remove the "loading" class which holds the loader image
          var parent = element.parentNode;
          parent.className = parent.className.replace(/\bloading\b/,'');
        }, 200);
        //console.log("Element loaded: ", element.nodeName);
      }
    });

    /**
     Ocultar el buscador del header al pulsar fuera
     */
    var buscador = $('#buscador-header');

    $(window).click(function (e) {
      if( $(e.target).closest("#buscador-header").length > 0 ) {
        return false;
      }
      else if ($("#buscador-header").is(":visible")){
        buscador.attr('hidden', true);
      }
    });


    /**
     * Al pulsar la lupa mostramos el desplegable y activamos el focus en el input
     */
    $('#dropdown-search i').click(function (event) {
      buscador.removeAttr('hidden');
      $('#buscador-header .tab-pane.active input').focus();
      event.stopPropagation();
    });

    $('.dropdown-buscadores .close-buscadores').click(function(){
      buscador.attr('hidden', true);
    });

    //Si cambiamos de pestaña también activamos el focus en el input
    $('#nav-tab-buscadores a[data-toggle="tab"]').on('shown.bs.tab', function(e){
      $('#buscador-header .tab-pane.active input').focus();
    });

    /**
     * Botón solicita información en versión móvil
     */
    var lastScrollTop = 0;
    $(window).scroll(function(event){
      var st = $(this).scrollTop();
      if (st > lastScrollTop) {
        $('#buttonSoliInfoMobile').css('bottom', '15px');
      } else {
        $('#buttonSoliInfoMobile').css('bottom', '-70px');
      }
      lastScrollTop = st;
    });

    /**
     * Control de visibilidad de filtros estudios
     */

    function init_filter_visibility() {

      if (($(window).width() <= 983) && ($('.filtros').is(':visible'))) {
        $('.filtros').hide();
        //console.log('hide filter');
      }

      if (($(window).width() > 983) && ($('.filtros').is(':hidden'))) {
        $('.filtros').show();
        //console.log('show filter');
      }

    }

    function set_body_overflow() {
      if ($('.filtros').is(':visible')) {
        $('body').addClass('body--blocked');
      } else {
        $('body').removeClass('body--blocked');
      }
    }

    init_filter_visibility();
    //breakpointChecker();

    $(window).resize(function() {
      init_filter_visibility();
      //breakpointChecker();
      //console.log($(window).width());
    });

    $('.js--control-filtros').click(function() {
      $('.filtros').toggle();
      set_body_overflow();
    });


  });

})(jQuery, Drupal);
